import { delay, Subject, takeUntil, tap } from 'rxjs';

import { DOCUMENT } from '@angular/common';
import { Component, inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'peca-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent implements OnInit, OnDestroy {
  renderer = inject(Renderer2);
  document = inject(DOCUMENT);
  confirmationService = inject(AlertService);
  confirmation: any | null = null;
  destroyRef$ = new Subject<void>();
  active = false;
  ready = false;

  ngOnInit(): void {
    this.confirmationService
      .listen()
      .pipe(
        takeUntil(this.destroyRef$),
        tap((confirmation) => {
          if (confirmation) {
            this.active = true;
            this.renderer.addClass(this.document.body, 'alert-hidden-overflow');
          } else {
            this.ready = false;
          }
          this.confirmation = confirmation;
        }),
        delay(128)
      )
      .subscribe((confirmation) => {
        if (!confirmation) {
          this.active = false;
          this.renderer.removeClass(this.document.body, 'alert-hidden-overflow');
        } else {
          this.ready = false;
        }
        this.confirmation = confirmation;
      });
  }

  ngOnDestroy(): void {
    this.destroyRef$.next();
    this.destroyRef$.unsubscribe();
  }

  onClickConfirm() {
    if (!this.confirmation) {
      return;
    }

    this.ready = false;
    this.active = false;
    this.renderer.removeClass(this.document.body, 'alert-hidden-overflow');
  }

  onClickDeny() {
    if (!this.confirmation) {
      return;
    }

    this.confirmation.answer.next(false);
    this.ready = false;
    this.active = false;
    this.renderer.removeClass(this.document.body, 'alert-hidden-overflow');
  }
}
